import {Observable} from 'rxjs';
import {Parameter} from '../common/parameter';
import { HttpParams } from '@angular/common/http';

export interface AssetParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface Asset {
    id?: any;
    tenantId: any;
    branchId: any;
    name:string;
    assetTypeId:any;
    
    parameters?: AssetParameter[];
    links?: any;
}

export interface AssetGroupList{
    assetGroupName :string,
    assetGroupId :string,
    assetCategoryName :string,
    assetCategoryId :string,
    assetSubCategoryName :string,
    assetSubCategoryId :string,
}

export interface AssetRegisterMaster {
        assetGroupId:number,
        assetNo:string,
        assetSerialNo:string,
        assetModelNo:string,
        assetMemoryNotes:string,
        assetDataSource:string,
        assetDataSourceRefId:string,
        assetCost:number,
        assetCostOnDate:Date,
        assetOpeningBal:number,
        assetOpeningBalDate:Date,
        tenantId:string,
        branchId:string,
        supplierId:string,
        purchaseDate:Date,
        purchaseOrderNo: string,
        supplierInvoiceNumber:string,
        addedBy:string,
        addedOn: Date,
        assetRetired:'Y'|'N',
        missingAsset:'Y'|'N',
        scrappedAsset: 'Y'|'N',
        assetCondition:string,
        assetAcquisitionCode:string,
        assetAssigned:boolean,
        assetUniqueId?:number,
        hmsLocation:number,
        rfidTagId:string
}

export interface AssetRegMstList{
    assetUniqueId:Number,
    assetCategoryName :string,
    assetSubCategoryName :string,
    assetGroupName :string,
    assetGroupCode :string,
    serialNo :string,
    modelNo :string,
    acquisition :string,
    assetLocation :string,
    custodian :string,
    assetCondition :string,
    assetCategoryId :number,
    assetSubCategoryId :number,
    assetGroupId :number,
    missing:'Y'|'N',
    retired:'Y'|'N',
    scrapped:'Y'|'N',
    assignedStatus:boolean,
    assetCustodianType:string,
    assetCustodianName:string,
    assetCustodianId:number,
    locationId?:number
}

export abstract class AssetData {
   
    abstract list(url: string): Observable<Asset[]>;
    abstract create(url: string, data: Asset): Observable<Asset[]>;
    abstract update(url: string, data: Asset): Observable<Asset>;
    abstract delete(url: string): Observable<any>;

    abstract assetRegMstlist<T>(url: string,queryParams?:HttpParams): Observable<T>;
    abstract assetRegMstCreate<T,R>(url: string, data:T): Observable<R>;
    abstract assetRegMstById<T>(url:string,queryParams:HttpParams): Observable<T>
    abstract assetRegMstUpdate<T,R>(url: string, data:T,queryParams:HttpParams): Observable<R>;

}